import { useData } from '../../contexts';
import { navigate } from 'gatsby';
import React from 'react';

export default function CitySearchForm({ cityDashboardPath, allCities }) {
  const { selectedGemeente, setSelectedGemeente, setSearchParams, blobUrl } =
    useData();

  const aplhabeticalCities = (allCities || []).map((d) => d.data.ruimte);

  const onChangeHandler = (event: any) => {
    let tmp = aplhabeticalCities.find((d: any) => d.id == event.target.value);
    tmp.label = tmp.ruimte;

    setSelectedGemeente(tmp);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    let tmpValue = JSON.parse(event.target.elements.city.value);
    let tmp = aplhabeticalCities.find((d: any) => d.id == tmpValue);

    const city = tmp.ruimte;

    setSearchParams((params) => {
      params.set('gemeente', city);
      return params;
    });
    navigate(`${cityDashboardPath}?gemeente=${city}`);
  };

  return (
    <form className="vl-form" onSubmit={handleSubmit}>
      <div className="vl-form-grid">
        <div className="vl-form-col--8-12 vl-form-col--12-12--s">
          <select
            id="homepageCitySelect"
            name="city"
            className="vl-select vl-select--block"
            tabIndex={0}
            data-vl-select={true}
            data-vl-select-search-empty-text="Geen resultaten gevonden"
            defaultValue={(selectedGemeente || aplhabeticalCities[0]).id}
            onChange={onChangeHandler}
          >
            {aplhabeticalCities.map((d: any) => (
              <option key={d.id} value={d.id}>
                {d.ruimte}
              </option>
            ))}
          </select>
        </div>
        <div className="vl-form-col--4-12 vl-form-col--12-12--s">
          <button
            type="submit"
            className="vl-button vl-button--icon-before vl-button--block"
            vl-button=""
          >
            <i
              className="vl-button__icon vl-button__icon--before vl-vi vl-vi-search"
              aria-hidden="true"
            ></i>
            <span className="vl-button__label">Ontdek de cijfers</span>
          </button>
        </div>
      </div>
    </form>
  );
}
